// A mangrove: a trunk lifted on a tangle of arching STILT ROOTS, with a low
// dense canopy — the signature swamp tree. Ported 1:1 from age-of-mcp's classic
// mangrove.ts, restoring its radial stilt-root loop.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [
    { geometry: new THREE.CylinderGeometry(0.09, 0.11, 0.7, 6),
      color: "#5b4630", position: [0, 0.62, 0] },
  ];
  // stilt roots splaying down and out
  const N = 5;
  for (let i = 0; i < N; i++) {
    const a = (i / N) * Math.PI * 2;
    parts.push({
      geometry: new THREE.CylinderGeometry(0.025, 0.05, 0.5, 4),
      color: "#4d3a26",
      position: [Math.cos(a) * 0.16, 0.22, Math.sin(a) * 0.16],
      rotation: [Math.sin(a) * 0.6, 0, -Math.cos(a) * 0.6],
    });
  }
  // low canopy
  parts.push({ geometry: new THREE.IcosahedronGeometry(0.5, 0), color: "#356b3c",
    position: [0, 1.1, 0] });
  parts.push({ geometry: new THREE.IcosahedronGeometry(0.34, 0), color: "#3f7d44",
    position: [0.28, 1.0, -0.1] });
  return parts;
}

export const mangrove = defineModel({
  id: "mangrove",
  batchId: "standard",
  name: "Mangrove",
  tags: ["scenery","mangrove","low-poly","age-of-mcp","classic","water"],
  summary: "Low-poly mangrove.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.6,
  parts: () => partsFor(),
  animations: [],
});
